module.exports = __webpack_public_path__ + "media/images/lb/002-7bff59d2df84d0425fada64de59e24ef.svg";